import angular from 'angular';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  activeActivityType: state.activity.activeActivityType,
});

angular
  .module('myConsultApp')
  .controller(
    'activityTypeCreateEditController',
    ($ngRedux, $scope, $rootScope, $timeout, $filter, $http, ENV) => {
      $scope.activityTypeProcessing = false;
      $scope.classifications = [];
      $scope.frequencyPeriods = [];
      $scope.promotionClassifications = [];

      $scope.extraKey = '';
      $scope.extraValue = '';

      $scope.isFormReadyForSubmit = false;

      $scope.init = () => {
        $scope.loadClassifications();
        $scope.loadFrequencyPeriods();
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      };

      $scope.clearActivityTypeCreateEdit = () => {
        $scope.activityTypeProcessing = false;
        $scope.heading = 'Create Activity Type';
        $scope.currentActivityType = {
          id: null,
          title: null,
          description: null,
          num_points: null,
          frequency_limited: false,
          frequency_cap: null,
          frequency_period: null,
          classification: null,
          date_start: null,
          date_end: null,
          manual_trigger_enabled: false,
          admin_only: false,
          allow_negative_points: false,
          extra_data: null,
        };

        if ($scope.activityTypeForm) {
          $scope.activityTypeForm.$setPristine();
          $scope.activityTypeForm.$setUntouched();
        }

        $scope.extraKey = '';
        $scope.extraValue = '';

        $scope.resetError();
      };

      $scope.resetError = () => {
        $scope.error = {
          statusCode: 0,
          statusText: '',
          highlightedFields: {
            title: [],
            description: [],
            num_points: [],
            frequency_cap: [],
            frequency_period: [],
            classification: [],
            date_start: [],
            date_end: [],
            manual_trigger_enabled: [],
            admin_only: [],
            allow_negative_points: [],
            extra_data: [],
          },
          details: [],
        };
      };

      $scope.loadClassifications = () => {
        $scope.getClassifications($http, ENV).then((classifications) => {
          $timeout(() => {
            $scope.classifications = classifications;
            $scope.promotionClassifications = classifications
              .filter((classification) => classification.name.includes('Promotion'))
              .map((classification) => classification.id);
          });
        });
      };

      $scope.loadFrequencyPeriods = () => {
        $scope.getFrequencyPeriods($http, ENV).then((frequencyPeriods) => {
          $timeout(() => {
            $scope.frequencyPeriods = frequencyPeriods;
          });
        });
      };

      $scope.setDateStart = (val) => {
        $scope.clearErrorField('date_start');
        $scope.currentActivityType.date_start = val;
      };

      $scope.setDateEnd = (val) => {
        $scope.clearErrorField('date_end');
        $scope.currentActivityType.date_end = val;
      };

      $scope.sanitizeData = (data) => {
        return Object.keys(data).reduce((acc, key) => {
          acc[key] = data[key] === '' ? null : data[key];
          return acc;
        }, {});
      };

      $scope.clearErrorField = (fieldName) => {
        if (fieldName) {
          $scope.error.highlightedFields[fieldName] = [];
        }
        $scope.error.details = [];
      };

      $scope.addExtraItem = () => {
        if (!$scope.extraKey || !$scope.extraValue) {
          return;
        }

        $scope.clearErrorField('extra_data');

        if ($scope.currentActivityType.extra_data === null) {
          $scope.currentActivityType.extra_data = {};
        }

        $scope.currentActivityType.extra_data[$scope.extraKey] = $scope.extraValue;
        $scope.extraKey = '';
        $scope.extraValue = '';
      };

      $scope.removeExtraItem = (extraKey) => {
        $scope.clearErrorField('extra_data');

        delete $scope.currentActivityType.extra_data[extraKey];

        if (isEmpty($scope.currentActivityType.extra_data)) {
          $scope.currentActivityType.extra_data = null;
        }
      };

      $scope.selectFrequencyUnlimited = () => {
        $scope.clearErrorField();

        $scope.currentActivityType.frequency_cap = null;
        $scope.currentActivityType.frequency_period = null;
      };

      $scope.validate = () => {
        const {
          title,
          description,
          frequency_limited,
          frequency_cap,
          frequency_period,
          date_start,
          date_end,
          classification,
        } = $scope.currentActivityType;

        if (!classification) {
          $scope.isFormReadyForSubmit = false;
          return;
        }

        const promotionClassification = title && description;
        const frequencyUnlimited = promotionClassification;
        const frequencyLimited = frequencyUnlimited && frequency_cap && frequency_period;

        if ($scope.promotionClassifications.includes(classification)) {
          $scope.isFormReadyForSubmit = promotionClassification;
          return;
        }

        if (date_start && date_end) {
          $scope.isFormReadyForSubmit = moment(date_end) > moment(date_start);
          return;
        }

        if (frequency_limited) {
          $scope.isFormReadyForSubmit = frequencyLimited;
        } else {
          $scope.isFormReadyForSubmit = frequencyUnlimited;
        }
      };

      $scope.submitActivityType = () => {
        $scope.activityTypeProcessing = true;
        const currentActivityType = $scope.currentActivityType;
        const isPromotionCode = $scope.promotionClassifications.includes(
          $scope.currentActivityType.classification,
        );

        const activityType = {
          title: currentActivityType.title,
          description: currentActivityType.description,
          num_points: isPromotionCode ? null : currentActivityType.num_points,
          classification: { id: currentActivityType.classification },
          frequency_cap: isPromotionCode ? null : currentActivityType.frequency_cap,
          frequency_period: { id: isPromotionCode ? null : currentActivityType.frequency_period },
          extra_data: currentActivityType.extra_data ? currentActivityType.extra_data : null,
          date_start: isPromotionCode ? null : currentActivityType.date_start,
          date_end: isPromotionCode ? null : currentActivityType.date_end,
          manual_trigger_enabled: currentActivityType.manual_trigger_enabled,
          admin_only: currentActivityType.admin_only,
          allow_negative_points: currentActivityType.allow_negative_points,
        };

        const payload = {
          'activity-types': $scope.sanitizeData(activityType),
        };

        const currentActivityTypeId = $scope.currentActivityType.id;

        if (!currentActivityTypeId) {
          $scope
            .createUserActivityType($http, ENV, payload)
            .then(() => {
              $timeout(() => {
                $scope.clearActivityTypeCreateEdit();
                $scope.activityTypeProcessing = false;
                $scope.close();
                $rootScope.getData();
              });
            })
            .catch((error) => $scope.applyError(error));
        } else {
          $scope
            .updateUserActivityType($http, ENV, currentActivityTypeId, payload)
            .then(() => {
              $timeout(() => {
                $scope.activityTypeProcessing = false;
                $scope.close();
                $rootScope.getData(true);
              });
            })
            .catch((error) => $scope.applyError(error));
        }
      };

      $scope.applyError = (error) => {
        $timeout(() => {
          $scope.error = {
            statusCode: error.status,
            statusText: error.statusText,
            highlightedFields: error.data['activity-types'],
            details: [],
          };

          $scope.error.details = $scope.getErrorDetails($scope.error);
          $scope.activityTypeProcessing = false;
        });
      };

      $scope.getErrorDetails = (error) => {
        const details = [];
        const { statusCode, statusText, highlightedFields } = error;

        if (statusCode === 500) {
          details.push([
            'There was an error with your request. Please try again in a few minutes.',
          ]);
        } else if (statusCode === 400) {
          const { errors } = highlightedFields;

          if (errors && errors.length > 0) {
            details.push(errors[0]);
          }

          if (Object.keys(highlightedFields).length > 0) {
            details.push('Please fix the highlighted field(s).');
          }
        } else {
          details.push(statusText);
        }

        return details;
      };

      $scope.setActivityTypeData = () => {
        if ($scope.activeActivityType) {
          $scope.currentActivityType = {
            ...$scope.activeActivityType,
            frequency_limited:
              $scope.activeActivityType.frequency_cap ||
              $scope.activeActivityType.frequency_period ||
              false,
            classification: $scope.activeActivityType.classification
              ? $scope.activeActivityType.classification.id
              : null,
            frequency_period: $scope.activeActivityType.frequency_period
              ? $scope.activeActivityType.frequency_period.id
              : null,
            frequency_cap: $scope.activeActivityType.frequency_cap
              ? Number($scope.activeActivityType.frequency_cap)
              : null,
            manual_trigger_enabled: $scope.activeActivityType.manual_trigger_enabled || false,
            admin_only: $scope.activeActivityType.admin_only || false,
            allow_negative_points: $scope.activeActivityType.allow_negative_points || false,
            num_points: $scope.activeActivityType.num_points
              ? Number($scope.activeActivityType.num_points)
              : null,
          };
          if ($scope.activeActivityType.extra_data) {
            if (typeof $scope.activeActivityType.extra_data === 'string') {
              $scope.currentActivityType.extra_data = JSON.parse(
                $scope.activeActivityType.extra_data,
              );
            } else {
              $scope.currentActivityType.extra_data = $scope.activeActivityType.extra_data;
            }
          } else {
            $scope.currentActivityType.extra_data = null;
          }
          $scope.validate();
        }
      };

      $scope.close = () => {
        $rootScope.closeComponent().then(() => {
          $scope.clearActivityTypeCreateEdit();
          $scope.clearActivityType();
        });
      };

      $scope.init();

      $scope.clearActivityTypeCreateEdit();

      const activeActivityTypeLister = $scope.$watch('activeActivityType', () => {
        if ($scope.activeActivityType) {
          $scope.setActivityTypeData();
        } else {
          $scope.clearActivityTypeCreateEdit();
        }
      });

      const activityPointsListener = $scope.$watch('currentActivityType.num_points', () => {
        if ($scope.currentActivityType.allow_negative_points && $scope.currentActivityType.num_points) {
          $scope.currentActivityType.num_points =
            Number($scope.currentActivityType.num_points
                .toString()
                .trim()
                .substring(0, 1)
                .replace(/[^0-9\-]/g, '') +
              $scope.currentActivityType.num_points
                .toString()
                .trim()
                .substring(1)
                .replace(/[^0-9]/g, ''));
        } else if ($scope.currentActivityType.num_points) {
          $scope.currentActivityType.num_points = Number($scope.currentActivityType.num_points
            .toString()
            .trim()
            .replace(/[^0-9]/g, ''));
        }
      });

      const activityPointsNegativeListener = $scope.$watch('currentActivityType.allow_negative_points', () => {
        if ($scope.currentActivityType.allow_negative_points && $scope.currentActivityType.num_points) {
          $scope.currentActivityType.num_points =
            Number($scope.currentActivityType.num_points
                .toString()
                .trim()
                .substring(0, 1)
                .replace(/[^0-9\-]/g, '') +
              $scope.currentActivityType.num_points
                .toString()
                .trim()
                .substring(1)
                .replace(/[^0-9]/g, ''));
        } else if ($scope.currentActivityType.num_points) {
          $scope.currentActivityType.num_points = Number($scope.currentActivityType.num_points
            .toString()
            .trim()
            .replace(/[^0-9]/g, ''));
        }
      });

      $scope.$on('$destroy', () => {
        $scope.unsubscribe();
        $scope.clearActivityTypeCreateEdit();
        activeActivityTypeLister();
        activityPointsListener();
        activityPointsNegativeListener();
      });
    },
  )
  .directive('activityTypeCreateEdit', () => {
    return {
      templateUrl: 'templates/v2/activity-type-create-edit.html',
    };
  });
